import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { InvoiceEnums } from 'src/app/enum/invoice-enums';
import { InvoiceDetailModel } from 'src/app/models/invoicing/invoice-detail.model';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { InvoiceDetailService } from 'src/app/services/invoicing/invoice-detail.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-invoice-detail',
  templateUrl: './register-invoice-detail.component.html',
  styleUrls: ['./register-invoice-detail.component.scss'],
  standalone: false
})
export class RegisterInvoiceDetailComponent implements OnChanges {
  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() defaultStoreIdForBranch: number | null = null;
  @Input() invoiceModel: InvoiceModel = new InvoiceModel();
  @Input() invoiceDetailContract: InvoiceDetailModel = new InvoiceDetailModel();
  @Output() invoiceContract = new EventEmitter<InvoiceModel>();
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  affectsInventory: boolean = false;
  articleId: number = 0;
  ascendantArticle: boolean = true;
  articleModaldisable: boolean = false
  columnSortArticle: string | null = null;
  componentTableSelection = CustomTableSelectComponent;
  conceptInvoicingId: number = 0;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  disableButtonSave: boolean = false;
  enableAffectsInventory: boolean = true;
  filtersArticle: ColumnResponseModel[] = [];
  formInvoiceDetail: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  invoiceDetailId: number = 0;
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: [],
  })
  limitArticle: number = 5;
  listArticles: any[] = [];
  listConceptInvoicing: any[] = [];
  listStore: any[] = [];
  listStoreFiltered: any[] = [];
  output$ = new Subject<any>();
  pageArticle: number = 1;
  stock: number = 0;
  storeId: number = 0;
  subscription: Subscription;

  constructor(private formBuilder: FormBuilder,
    private articleService: ArticleService,
    private invoiceDetailService: InvoiceDetailService,
    private invoiceService: InvoiceService,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm(this.invoiceDetailContract);
    this.getAllLists();
  }

  async ngOnInit() {
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const invoiceDetailContract = changes["invoiceDetailContract"];
    if (invoiceDetailContract) {
      if (this.invoiceDetailContract.invoiceDetailId == 0) {
        this.createNewInvoicingDetail();
        this.filterStoreByBranch();
      } else {
        this.invoiceDetailId = this.invoiceDetailContract.invoiceDetailId;
        this.validateForm(this.invoiceDetailContract);
        this.getArticle(this.invoiceDetailContract.articleId, false);
        this.calculateTotalValue();
        this.filterStoreByBranch();
        this.getStocksByArticleId(this.invoiceDetailContract.articleId, this.invoiceDetailContract.storeId);
      }
      if (this.invoiceDetailContract.invoiceDetailId == 0 && this.conceptInvoicingId != 0 && this.articleId != 0) {
        this.getPriceArticleByConceptInvoicing(this.invoiceModel.invoiceId, this.conceptInvoicingId, this.articleId);
      }

      this.invoiceModel.invoicingCutoffId ? setTimeout(() => this.formInvoiceDetail.controls["residue"].enable(), 100)
        : setTimeout(() => this.formInvoiceDetail.controls["residue"].disable(), 100);
      setTimeout(() => this.formInvoiceDetail.controls["totalValueWithDiscount"].disable(), 100);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  calculateTotalValue() {
    const residue = this.formInvoiceDetail.get("residue")?.value;
    const totalTime = this.formInvoiceDetail.get("totalTime")?.value;
    const unitValueWithDiscount = this.formInvoiceDetail.get("unitValueWithDiscount")?.value;
    //Calculo el vr total del artículo
    const totalValue = (residue * totalTime * unitValueWithDiscount);
    this.formInvoiceDetail.controls["totalValueWithDiscount"].patchValue(totalValue);
    //Asigno el vr sin descuento
    this.formInvoiceDetail.controls["unitValueWithoutDiscount"].patchValue(unitValueWithDiscount);
  }

  changeDateIni(dateIni: Date | null) {
    this.formInvoiceDetail.controls["dateFinal"].patchValue(dateIni);
    this.changeDateFin();
  }

  changeDateFin() {
    const fechaIni = this.convertStringToDate(this.formInvoiceDetail.get("dateInitial")?.value);
    const fechaFin = this.convertStringToDate(this.formInvoiceDetail.get("dateFinal")?.value);
    if (fechaFin < fechaIni) {
      this.toastHandlerService.showToast('warning', 'La fecha final debe ser MAYOR a la fecha inicial.');
    }
    const diffTime = Math.abs(fechaFin.getTime() - fechaIni.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const totalDias = diffDays;
    this.formInvoiceDetail.controls["totalTime"].patchValue(totalDias + 1);
    this.calculateTotalValue();
  }

  changeQuantity() {
    const quantity = this.formInvoiceDetail.get("quantity")?.value;
    this.formInvoiceDetail.controls["residue"].patchValue(quantity);
    if (quantity < 0 || !quantity) {
      this.toastHandlerService.showToast('warning', 'La cantidad a facturar es menor o igual a cero.');
      return;
    }
    this.calculateTotalValue();
  }

  cancel() {
    this.clearForm();
    this.isFormView.emit(false);
  }

  clearForm() {
    this.articleId = 0;
    this.conceptInvoicingId = 0;
    this.stock = 0;
    this.storeId = 0;
    this.articleModaldisable = false;
    this.invoiceDetailContract = new InvoiceDetailModel;
    this.validateForm(this.invoiceDetailContract);
  }

  convertStringToDate(dateString: string | Date): Date {
    if (typeof dateString === 'string') {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(year, month - 1, day);
    } else {
      return dateString;
    }
  }

  convertUtcToLocalDate(dateStr: string | Date): Date {
    const utcDate = new Date(dateStr);
    return new Date(
      utcDate.getUTCFullYear(),
      utcDate.getUTCMonth(),
      utcDate.getUTCDate()
    );
  }

  createNewInvoicingDetail() {
    this.invoiceDetailId = 0;
    this.articleModaldisable = false;
    this.disableButtonSave = false;
    this.validateForm(this.invoiceDetailContract);
  }

  filterStoreByBranch() {
    this.listStoreFiltered = this.listStore.filter(x => x.branchId == this.invoiceModel.branchId);
  }

  async getAllLists() {
    try {
      const [conceptsInvoicing, stores, articles] = await Promise.all([
        firstValueFrom(this.invoiceDetailService.getAllConceptInvoicingForSelectAsync()),
        firstValueFrom(this.invoiceDetailService.getAllStoreForSelectAsync()),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
      ]);
      this.listConceptInvoicing = conceptsInvoicing;
      this.listStore = stores;
      this.listArticles = articles;
      this.filterStoreByBranch();
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getArticle(articleId: number | null, reload: boolean) {
    if (articleId != null && articleId != 0) {
      const article = await firstValueFrom(this.invoiceDetailService.getArticleById(articleId));
      if (article) {
        if (this.conceptInvoicingId == null || this.conceptInvoicingId == 0) {
          this.toastHandlerService.showToast('warning', 'Debe seleccionar el concepto de facturación.');
          return;
        }
        this.articleId = articleId;
      } else {
        this.articleId = 0;
        return;
      }
      if (reload) {
        const storeId = this.defaultStoreIdForBranch !== 0 ? this.defaultStoreIdForBranch : null;
        this.getStore(storeId, true);
      }
    } else {
      this.articleId = 0;
      if (reload) {
        this.invoiceDetailContract = new InvoiceDetailModel();
        this.invoiceDetailContract.articleId = 0;
        this.invoiceDetailContract.conceptInvoicingId = this.conceptInvoicingId;
        this.invoiceDetailContract.affectsInventory = this.affectsInventory;
        this.invoiceDetailContract.storeId = 0;
        this.validateForm(this.invoiceDetailContract);
      }
    }
  }

  async getArticlesForInvoices() {
    try {
      this.dataArticle = await firstValueFrom(this.invoiceDetailService.getArticlesForInvoices(this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));

      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {
      this.headerArticle = await firstValueFrom(this.invoiceDetailService.getColumnsForArticles());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getConceptInvoicing(conceptInvoicingId: number | null, reload: boolean) {
    if (conceptInvoicingId != null && conceptInvoicingId != 0) {
      const conceptInvoicing = this.listConceptInvoicing.find(x => x.value == conceptInvoicingId);

      if (conceptInvoicing) {
        this.conceptInvoicingId = conceptInvoicingId;
        this.affectsInventory = conceptInvoicing.affectsInventory === true;
        setTimeout(() => this.formInvoiceDetail.controls["affectsInventory"].patchValue(this.affectsInventory), 150);
        //Validación para habilitar sw afecta inventario
        this.affectsInventory && this.invoiceDetailContract.invoiceDetailId == 0 ? this.enableAffectsInventory = false : this.enableAffectsInventory = true;
      } else {
        this.conceptInvoicingId = 0;
        return;
      }

      if (reload) {
        this.articleId = 0;
        this.storeId = 0;
        this.stock = 0;
        const modelInvoiceDetail = new InvoiceDetailModel;
        modelInvoiceDetail.articleId = 0;
        modelInvoiceDetail.conceptInvoicingId = this.conceptInvoicingId;
        modelInvoiceDetail.affectsInventory = this.affectsInventory;
        modelInvoiceDetail.storeId = 0;
        this.invoiceDetailContract = modelInvoiceDetail;
        this.validateForm(this.invoiceDetailContract);
      }
    } else {
      this.conceptInvoicingId = 0;
      if (reload) {
        this.articleId = 0;
        this.storeId = 0;
        this.stock = 0;
        this.invoiceDetailContract = new InvoiceDetailModel();
        this.validateForm(this.invoiceDetailContract);
      }
    }
  }

  async getInvoiceById(invoiceById: number) {
    try {
      this.invoiceContract.emit(await firstValueFrom(this.invoiceService.getInvoiceById(invoiceById)));
    } catch (error) {
      console.error('Error al buscar la factura por id.', error);
    }
  }

  async getPriceArticleByConceptInvoicing(invoiceId: number, conceptInvoicingId: number, articleId: number) {
    try {
      this.formInvoiceDetail.controls["unitValueWithDiscount"].patchValue(
        await firstValueFrom(this.invoiceDetailService.getPriceArticleByConceptInvoicing(invoiceId, conceptInvoicingId, articleId)));
    } catch (error) {
      this.formInvoiceDetail.controls["unitValueWithDiscount"].patchValue(0);
      console.error('Error al buscar el precio del articulo por concepto de facturacion.', error);
    }
  }

  //Obtiene la cantidad del artículo en el almacén.
  async getStocksByArticleId(articleId: number, storeId: number) {
    if (articleId != null && articleId != 0 && storeId != null && storeId != 0) {
      const rentalStockModel = new RentalStockModel();
      rentalStockModel.articleId = this.articleId;
      rentalStockModel.storeId = this.storeId;
      rentalStockModel.dateMovement = this.invoiceModel.dateInvoice;
      try {
        this.stock = await firstValueFrom(this.invoiceDetailService.getStocksByArticleIdStoreId(rentalStockModel));
      } catch (error) {
        console.error('Error al buscar el stock del articulo.', error);
      }
    }
  }

  async getStore(storeId: number | null, reload: boolean) {
    if (storeId != null && storeId != 0) {
      if (this.articleId == null || this.articleId == 0) {
        this.toastHandlerService.showToast('warning', 'Debe seleccionar el artículo.');
        return;
      }
      this.storeId = storeId;
      this.formInvoiceDetail.controls["storeId"].patchValue(this.storeId);
      this.getStocksByArticleId(this.articleId, this.storeId);
    } else {
      this.stock = 0;
      this.storeId = 0;
      this.formInvoiceDetail.controls["storeId"].patchValue(this.storeId);
      if (reload) {
        const modelInvoiceDetail = new InvoiceDetailModel();
        modelInvoiceDetail.articleId = this.articleId;
        modelInvoiceDetail.conceptInvoicingId = this.conceptInvoicingId;
        modelInvoiceDetail.affectsInventory = this.affectsInventory;
        modelInvoiceDetail.storeId = 0;
        this.invoiceDetailContract = modelInvoiceDetail;
        this.validateForm(this.invoiceDetailContract);
      }
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.getArticle(articleId, true)
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getArticlesForInvoices();
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  send() {
    if (this.formInvoiceDetail.controls["quantity"].value == 0 || this.formInvoiceDetail.controls["unitValueWithDiscount"].value == 0) {
      Swal.fire({
        icon: 'question',
        title: 'Atención.',
        text: "La cantidad o el valor de artículos a facturar es cero. ¿Realmente desea ingresar el registro?.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendDetail();
        }
      })
    } else {
      this.sendDetail();
    }
  }

  async sendDetail(): Promise<any> {
    //Asigno la clave de la Factura y el articulo seleccionado
    this.formInvoiceDetail.controls["invoiceId"].patchValue(this.invoiceModel.invoiceId);
    this.formInvoiceDetail.controls["articleId"].patchValue(this.articleId);
    //Habilito campos para que el formulario los tome
    this.formInvoiceDetail.controls["residue"].enable();
    this.formInvoiceDetail.controls["totalValueWithDiscount"].enable();

    if (this.formInvoiceDetail.valid) {
      const modelInvoiceDetail = this.formInvoiceDetail.value as InvoiceDetailModel;
      modelInvoiceDetail.dateInitial = this.convertStringToDate(modelInvoiceDetail.dateInitial);
      modelInvoiceDetail.dateFinal = this.convertStringToDate(modelInvoiceDetail.dateFinal);
      if (modelInvoiceDetail.document == "") modelInvoiceDetail.document = null;

      if (this.invoiceDetailId == 0) {
        try {
          const response = await firstValueFrom(this.invoiceDetailService.createInvoiceDetail(modelInvoiceDetail));
          this.toastHandlerService.showToast('success', 'El detalle de la factura fue creado exitosamente.');
          this.getInvoiceById(response.invoiceId);
          this.invoiceDetailContract = new InvoiceDetailModel();
          this.clearForm();
          this.updateListDetail.emit(true);
        } catch (error) {
          console.error('Error al crear el detalle de la factura.', error);
        }
      } else {
        this.invoiceDetailContract.articleId = modelInvoiceDetail.articleId;
        this.invoiceDetailContract.dateInitial = this.convertStringToDate(modelInvoiceDetail.dateInitial);
        this.invoiceDetailContract.dateFinal = this.convertStringToDate(modelInvoiceDetail.dateFinal);
        this.invoiceDetailContract.document = modelInvoiceDetail.document;
        this.invoiceDetailContract.quantity = modelInvoiceDetail.quantity;
        this.invoiceDetailContract.residue = modelInvoiceDetail.residue;
        this.invoiceDetailContract.unitValueWithDiscount = modelInvoiceDetail.unitValueWithDiscount;
        this.invoiceDetailContract.unitValueWithoutDiscount = modelInvoiceDetail.unitValueWithoutDiscount;
        this.invoiceDetailContract.totalTime = modelInvoiceDetail.totalTime;
        this.invoiceDetailContract.totalValueWithDiscount = modelInvoiceDetail.totalValueWithDiscount;
        this.invoiceDetailContract.accountingCostCenter = modelInvoiceDetail.accountingCostCenter;
        try {
          const response = await firstValueFrom(this.invoiceDetailService.updateInvoiceDetail(this.invoiceDetailContract));
          this.toastHandlerService.showToast('success', 'El detalle de la factura fue modificada exitosamente.');
          this.getInvoiceById(response.invoiceId);
          this.invoiceDetailContract = new InvoiceDetailModel();
          this.clearForm()
          this.updateListDetail.emit(true);
        } catch (error) {
          this.updateListDetail.emit(true);
          console.error('Error al actualizar el detalle de la factura.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Todos los campos marcados con (*) son obligatorios.');
    }
    //Inhabilito campos
    this.invoiceModel.invoicingCutoffId ? setTimeout(() => this.formInvoiceDetail.controls["residue"].enable(), 100)
      : setTimeout(() => this.formInvoiceDetail.controls["residue"].disable(), 100);
    this.formInvoiceDetail.controls["totalValueWithDiscount"].disable();
  }


  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForInvoices()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  validateForm(invoiceDetailModel: InvoiceDetailModel) {
    this.formInvoiceDetail = this.formBuilder.group({
      invoiceId: [invoiceDetailModel.invoiceId, [Validators.required, Validators.min(1)]],
      articleId: [invoiceDetailModel.articleId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [invoiceDetailModel.conceptInvoicingId, [Validators.required, Validators.min(1)]],
      storeId: [invoiceDetailModel.storeId, [Validators.required, Validators.min(1)]],
      affectsInventory: [invoiceDetailModel.affectsInventory, []],
      document: [invoiceDetailModel.document, [Validators.maxLength(10)]],
      dateInitial: [new Date(invoiceDetailModel.dateInitial).toLocaleDateString('es-US'), [Validators.required]],
      dateFinal: [new Date(invoiceDetailModel.dateFinal).toLocaleDateString('es-US'), [Validators.required]],
      totalTime: [invoiceDetailModel.totalTime, [Validators.required]],
      quantity: [invoiceDetailModel.quantity, [Validators.required]],
      residue: [invoiceDetailModel.residue, [Validators.required]],
      unitValueWithDiscount: [invoiceDetailModel.unitValueWithDiscount, [Validators.required]],
      unitValueWithoutDiscount: [invoiceDetailModel.unitValueWithoutDiscount, [Validators.required]],
      totalValueWithDiscount: [invoiceDetailModel.totalValueWithDiscount, [Validators.required]],
      accountingCostCenter: [invoiceDetailModel.accountingCostCenter, [Validators.maxLength(50)]],
    });
    this.articleId = invoiceDetailModel.articleId;
    this.conceptInvoicingId = invoiceDetailModel.conceptInvoicingId;
    this.storeId = invoiceDetailModel.storeId;
    if (this.invoiceModel.invoiceStateId != InvoiceEnums.abierta) this.disableButtonSave = true;
    if (invoiceDetailModel.invoiceDetailId != 0) {
      this.formInvoiceDetail.controls["conceptInvoicingId"].disable();
      this.formInvoiceDetail.controls["storeId"].disable();
      this.formInvoiceDetail.controls["affectsInventory"].disable();
      this.articleModaldisable = true;
    }
    setTimeout(() => this.formInvoiceDetail.controls["accountingCostCenter"].disable());
    this.invoiceModel.invoicingCutoffId ? setTimeout(() => this.formInvoiceDetail.controls["residue"].enable(), 100)
      : setTimeout(() => this.formInvoiceDetail.controls["residue"].disable(), 100);
    setTimeout(() => this.formInvoiceDetail.controls["totalValueWithDiscount"].disable(), 100);
  }
}
